import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "60fa9c4UYNEOqH6dAT/Kfka", "ScrollBase", undefined);

import { _decorator, Component, Layout, ScrollView, v2, UITransform } from 'cc';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var ScrollBase = (_dec = ccclass('ScrollBase'), _dec(_class = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ScrollBase, _Component);

  function ScrollBase() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "layoutType", Layout.Type.NONE);

    _defineProperty(_assertThisInitialized(_this), "_spacingX", 0);

    _defineProperty(_assertThisInitialized(_this), "_spacingY", 0);

    _defineProperty(_assertThisInitialized(_this), "_paddingLeft", 0);

    _defineProperty(_assertThisInitialized(_this), "_paddingRight", 0);

    _defineProperty(_assertThisInitialized(_this), "_paddingBottom", 0);

    _defineProperty(_assertThisInitialized(_this), "_paddingTop", 0);

    _defineProperty(_assertThisInitialized(_this), "_sv", null);

    _defineProperty(_assertThisInitialized(_this), "_content", null);

    _defineProperty(_assertThisInitialized(_this), "_totalNum", 0);

    _defineProperty(_assertThisInitialized(_this), "_pfb", null);

    _defineProperty(_assertThisInitialized(_this), "_totalLength", 0);

    _defineProperty(_assertThisInitialized(_this), "_num_h", 0);

    _defineProperty(_assertThisInitialized(_this), "_num_v", 0);

    return _this;
  }

  var _proto = ScrollBase.prototype;

  //水平 -  竖直  -  二维竖直
  _proto.start = function start() {
    var _this2 = this;

    // [3]
    this._sv = this.node.getComponent(ScrollView);
    this._content = this._sv.content;
    this._layout = this._content.getComponent(Layout);
    this._paddingBottom = this._layout.paddingBottom;
    this._paddingLeft = this._layout.paddingLeft;
    this._paddingRight = this._layout.paddingRight;
    this._paddingTop = this._layout.paddingTop;
    this._spacingY = this._layout.spacingY;
    this._spacingX = this._layout.spacingX;

    this._sv.scrollTo(v2(0, 0));

    this.scheduleOnce(function () {
      _this2._prePos_content = _this2._content.position;
    }, 0);

    this._sv.node.on("scrolling", this.scrolling, this);
  }
  /**更新预制体个数 */
  ;

  _proto.init = function init(totalNum, pfb) {
    if (pfb) {
      this._pfb = pfb;
    }

    var w = this._pfb.data.width;
    var h = this._pfb.data.height;
    this._totalNum = totalNum;

    switch (this.layoutType) {
      case Layout.Type.GRID:
        this._num_h = Math.floor(this._sv.node.getComponent(UITransform).contentSize.width / (w + this._spacingX));
        this._num_v = Math.ceil(totalNum / this._num_h);
        this._totalLength = totalNum * (h + this._spacingY) + this._paddingBottom + this._paddingTop;
        break;

      case Layout.Type.HORIZONTAL:
        this._totalLength = totalNum * (w + this._spacingX) + this._paddingLeft + this._paddingRight;
        this._num_h = totalNum;
        break;

      case Layout.Type.VERTICAL:
        this._totalLength = totalNum * (h + this._spacingY) + this._paddingBottom + this._paddingTop;
        this._num_v = totalNum;
        break;
    }
  };

  _proto.scrolling = function scrolling(sv) {
    for (var i = 0; i < this._content.children.length; i++) {
      switch (this.layoutType) {
        case Layout.Type.HORIZONTAL:
          this.lr(sv, this._content.children[i]);
          break;

        case Layout.Type.VERTICAL:
        case Layout.Type.GRID:
          this.ud(sv, this._content.children[i]);
          break;
      }
    }
  }
  /**竖直滑动 */
  ;

  _proto.ud = function ud(sv, n_cur) {
    var isUp = false;

    if (this._prePos_content.y < this._content.position.y) {
      isUp = true;
    }
  }
  /**水平滑动 */
  ;

  _proto.lr = function lr(sv, n_cur) {
    var isL = false;

    if (this._prePos_content.x > this._content.position.x) {
      isL = true;
    }
  } // update (deltaTime: number) {
  //     // [4]
  // }
  ;

  return ScrollBase;
}(Component), _temp)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();